import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexColCenterVertical,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TableRow, TableTd } from '../../Zemplin/General/Table';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { CountSetter } from '../Product/CountSetter';
import { ProductPriceCartTable } from '../Product/ProductPriceCartTable';
import { ButtonWithRequest } from '../Product/ButtonWithRequest';
import { useState } from 'react';
import { __, __r } from 'react-i18n/lib';
import { IconImg } from '../../..';
import LinkError = WebAssembly.LinkError;
import { formatPrice, getOrderColor, prop } from '../../../utilities';
import { getOrderRowInfo } from '../../../utilities/selectors';

export interface Props {
  order: any;
  theme: any;
}

function OrderRow({ order, theme }: Props) {
  const { date, sumPrice, currency, ordernr, orderPublicId } = getOrderRowInfo(
    order,
  );
  const orderStatus = prop(order, 'order_status');
  const resolveNameBasedOnStatus = oStatus => {
    switch (oStatus) {
      case 'NOT_DELIVERED':
        return __('Nedodaná');
      case 'PARTIALLY_DELIVERED':
        return __('Čiastočne vybavená');
      case 'DELIVERED':
        return __('Dodaná');
      case 'CANCELLED':
        return __('Stornovaná');

      default:
        return __('Nedodaná');
    }
  };

  const resolveColorBasedOnStatus = oStatus => {
    switch (oStatus) {
      case 'NOT_DELIVERED':
        return theme.colors.dangerColor;
      case 'PARTIALLY_DELIVERED':
        return theme.colors.primary;
      case 'DELIVERED':
        return theme.colors.successColor;
      case 'CANCELLED':
        return theme.colors.black;

      default:
        return theme.colors.dangerColor;
    }
  };

  return (
    <>
      <StyledTableRow>
        <StyledTableTd>
          <StyledLink
            key={1}
            to={`${__r(
              'routes:moj-ucet/objednavka',
              '/moj-ucet/objednavka',
            )}/${orderPublicId}`}
          >
            <StatusText>{`${prop(order, 'outer_id')}`}</StatusText>
          </StyledLink>
        </StyledTableTd>
        <StyledTableTd>
          <StyledLink
            key={1}
            to={`${__r(
              'routes:moj-ucet/objednavka',
              '/moj-ucet/objednavka',
            )}/${orderPublicId}`}
          >
            <StatusText>{`${date}`}</StatusText>
          </StyledLink>
        </StyledTableTd>
        <StyledTableTd>
          {' '}
          <StyledLink
            key={1}
            to={`${__r(
              'routes:moj-ucet/objednavka',
              '/moj-ucet/objednavka',
            )}/${orderPublicId}`}
          >
            <StatusText statusColor={resolveColorBasedOnStatus(orderStatus)}>
              {resolveNameBasedOnStatus(orderStatus)}
            </StatusText>
          </StyledLink>
        </StyledTableTd>
        <StyledTableTd fullWidth={true}>
          <StyledLink
            key={1}
            to={`${__r(
              'routes:moj-ucet/objednavka',
              '/moj-ucet/objednavka',
            )}/${orderPublicId}`}
          >
            <StatusText align={'right'}>
              {formatPrice(sumPrice, currency)}
            </StatusText>
          </StyledLink>
        </StyledTableTd>
      </StyledTableRow>
    </>
  );
}

const StyledTableTd = styled(TableTd)<{ align?: boolean; fullWidth?: boolean }>`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'initial')};
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};
  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const StatusText = styled(TextP)<{ align?: string; statusColor?: string }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme, statusColor }) => statusColor && statusColor};
  font-weight: 400;
  text-align: ${({ align }) => (align ? align : 'left')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const WithThemeRow: any = withTheme(OrderRow);
export { WithThemeRow as DsiOrderRow };
